(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldHidden', fbFieldHiddenDirective);

    function fbFieldHiddenDirective() {
        return {
            restrict: "EA",
            scope: {
                element:'=',
                model: '='
            },
            template: ' <input type="hidden" ng-model="vm.model" />',
            controller: fbFieldHiddenDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFieldHiddenDirectiveCtrl() {

    }
})();